export const mapPlanosPorDireitoParaGerenciadorDeLicencas = (planosPorDireito)=>{
    return planosPorDireito.map(plano => {
        return {
          value: plano.produtoId,
          label: `${plano.produto} - ${plano.simboloMoeda} ${plano.valorVendaBhs}${plano.unidade ? ' | ' + plano.unidade : ''}`,
          moeda: plano.moeda,
          simboloMoeda: plano.simboloMoeda,
          valorVenda: plano.valorVendaBhs,
          unidadeId: plano.unidadeId,
          unidade: plano.unidade
        };
    });
}
export const maplicencasAdicionaisPorDireitoParaGerenciadorDeLicencas = (licencasAdicionaisPorDireito)=>{
    return licencasAdicionaisPorDireito.map(licenca => {
        return {
          value: licenca.produtoId,
          label: `${licenca.produto} - ${licenca.simboloMoeda} ${licenca.valorVendaBhs}${licenca.unidade ? ' | ' + licenca.unidade : ''}`,
          moeda: licenca.moeda,
          simboloMoeda: licenca.simboloMoeda,
          valorVenda: licenca.valorVendaBhs,
          unidadeId: licenca.unidadeId,
          unidade: licenca.unidade
        };
    });
}